import styles from './WithPlaceholder.module.scss';

interface WithPlaceholderProps {
  show: boolean;
  placeholderText: string;
  children: (props: { 'data-placeholder'?: string }) => JSX.Element;
}

const WithPlaceholder = ({ show, placeholderText, children }: WithPlaceholderProps) => {
  const props = show ? { 'data-placeholder': placeholderText } : {};
  return <div className={styles['with-placeholder']}>{children(props)}</div>;
};

export default WithPlaceholder;
